import {Component, Input, Output, OnInit, OnChanges, EventEmitter, DestroyRef, inject} from '@angular/core';
import { formatDate } from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {NotificationService} from '@emm/shared/services/notification.service';
import {LanguageAssignments} from '@emm/core/models/language-assignments.model';
import {API_ERRORS} from "@emm/core/util/api-constants";

@Component({
    selector: 'emm-language-assignments-form',
    templateUrl: './language-assignments-form.component.html',
    styleUrls: ['./language-assignments-form.component.scss'],
    standalone: false
})
export class LanguageAssignmentsFormComponent implements OnInit, OnChanges {

    @Input() showResult;
    @Input() english;
    @Input() spanish;
    @Input() date;
    @Input() location;
    @Input() isSuperAdmin: boolean;
    @Input() isAdmin: boolean;
    canEdit: boolean;
    newDate: any;

    @Output() languageAssignmentSaved = new EventEmitter<any>();

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    constructor(
        private managementApiService: ManagementApiService,
        private notificationService: NotificationService) {
    }

    ngOnInit(): void {
        this.canEdit = this.isSuperAdmin || this.isAdmin;
    }

    ngOnChanges(): void {
        this.newDate = new Date(this.date);
        this.newDate.setDate(this.newDate.getDate() + 1);
    }

    selectOpenDate(date: string) {
        this.newDate = date;
    }

    onSubmit(): void {
        const isEnglish = this.english === 'TRUE';

        const newLanguageAssignment: LanguageAssignments = {
            effectiveDate: formatDate(this.newDate, 'yyyy-MM-dd', 'en-US'),
            location: this.location,
            english: isEnglish,
            spanish: this.spanish,
        };

        this.managementApiService.saveLanguageAssignment(newLanguageAssignment)
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe({
                next: (result) => {
                    this.notificationService.success('Success saving Language Assignment');
                    this.languageAssignmentSaved.emit();
                },
                error: (error) => {
                    this.notificationService.error(error?.error?.error.message || API_ERRORS.GenericErrorMessage);
                }
            });
    }
}
